/**
 * BLOCK: clients Section
 */
registerBlockType( 'tornado/clients-section', {
    title: 'عملائنا',
    description: __('', 'tornado'),
    icon:'editor-insertmore',
    category:'tornado',
    keywords: [ 'clients', 'tornado', 'home'],
    supports: {
        align: ['full','wide']
    },
    attributes : {
        title : {
            type: 'string',
            default: 'عملائنا',
        },
        posts_number : {
            type: 'string',
            default: 12,
        },
    },
    //==== Edit Mode ====//
    edit: props => {
        const { attributes, setAttributes } = props;
        props.setAttributes( { align: 'full' } );
        //==== Set new Data ====//
        const set_title = value => setAttributes({ title: value });
        const set_posts_number = value => setAttributes({ posts_number: value });
        // Rendering in PHP
        return (
            <Panel>
                <InspectorControls key="inspector">
                    <PanelBody title={ __('Block Options', 'tornado') }>
                        {/*=== Section Title ===*/}
                        <TextControl key="title" label="عنوان القطعه" value={ attributes.title } onChange={ set_title } />
                        {/* //=== URL Input Control ===// */}
                        <TextControl type="number" key="clients-number" label="عدد البوستات" value={ attributes.posts_number } onChange={ set_posts_number } />
                    </PanelBody>
                </InspectorControls>
                <PanelBody>
                    <ServerSideRender block="tornado/clients-section" attributes={{
                        title   : attributes.title,
                        posts_number     : attributes.posts_number,
                    }} />
                </PanelBody>
            </Panel>
        )
    },

    save() { // Rendering in PHP
        return null;
    },
});